import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}

interface TabState {
  page: string;
  searchParams: any | null;
}

// 공헌도집계현황
const SN_EIS_SAL_REP_004 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
    grid2: React.createRef<SnGridRef>(),
    grid3: React.createRef<SnGridRef>(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [tabPageState, setTabState] = useState<TabState>({
    page: "1",
    searchParams: null,
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error: any) {}
    };

    fetchform();
  }, [Menuprops]);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_eis_sal_rep_004_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
    } catch (error: any) {}
  };

  const onTabChanged = async (index: string) => {
    setTabState({ page: index, searchParams: null });
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 flex flex-col gap-1.5 min-h-0">
        <SnTab
          titles={["품목별", "거래처별", "사원별"]}
          width={"100%"}
          selectedTab={tabPageState.page}
          onTabChanged={onTabChanged}
          body={[
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{ rowSelection: "multiple" }}
            />,
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{ rowSelection: "multiple" }}
            />,
            <SnGrid
              ref={gridRefs.current["grid3"]}
              columnConfig={grids.grid3.columns}
              rowData={grids.grid3.dataSource}
              etcProps={{ rowSelection: "multiple" }}
            />,
          ]}
        />
      </div>
    </div>
  );
});

export default SN_EIS_SAL_REP_004;
